module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp13_5010.1ee75df6.png";